"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formRules = exports.defaultFormData = void 0;
var defaultFormData = exports.defaultFormData = {
  pageName: '',
  // 名称
  popupIntro: '',
  // 简介
  popupAvatar: '',
  // 头像
  qrcodeImage: '',
  // 图片
  jumpUrl: '',
  // 跳转链接
  jumpLevel: 1,
  isEnabled: true // 是否启用
};
var formRules = exports.formRules = {
  pageName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入客服名称'
  }],
  popupAvatar: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择客服头像'
  }],
  qrcodeImage: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择客服展示图'
  }],
  jumpUrl: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入跳转链接'
  }]
};